<div class="white-box">
  <ng-container *ngIf="showI4KNameList$ | async; else editName">
    <h3 class="ui-headline">{{ 'profile.I4K.title' | translate }}</h3>
    <p>{{ 'kids.accounts_screen.p2' | translate }}</p>
    <ng-container *ngFor="let kidAccount of kidAccounts">
      <app-profile-i4k-row [kidAccount]="kidAccount" (editName)="onEditName($event)"></app-profile-i4k-row>
    </ng-container>
    <p class="profile-i4k-disclaimer">{{ 'profile.I4K.p2' | translate }}</p>
  </ng-container>
  <ng-template #editName>
    <h3 class="ui-headline">{{ 'profile.I4K.update.title' | translate }}</h3>
    <form [formGroup]="nameForm" #nameFormDirective="ngForm" (ngSubmit)="onSubmit()">
      <div class="input-box">
        <label for="first-name">{{ 'kids.register_screen.f_name' | translate }}</label>
        <input appAutoFocus id="first-name" type="email" formControlName="firstName" />
        <p *ngIf="nameFormDirective?.submitted && firstNameControl?.hasError('required')" class="error empty">
          {{ 'account.personal-information.error.name' | translate }}
        </p>
      </div>
      <div class="ui-button-group">
        <button type="submit" class="ui-button" [class.loading]="loading$ | async">
          <span class="icon-i-windmill"></span>
          {{ 'personal.send' | translate }}
        </button>
        <button (click)="onCancel()" class="ui-button-text">
          <span>{{ 'modals.consultation.cta.cancel' | translate }}</span>
        </button>
      </div>
    </form>
  </ng-template>
</div>
